import React from 'react';
import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { Touchable, HeaderText } from '../../../ui';
import ShareArrowIcon from '../ShareArrowIcon';

export const ReferralShareButton: React.FC<{
  onClick: () => void;
}> = ({
  onClick,
}) => (
  <Touchable onClick={onClick} testID="referral-share-button">
    <Box
      padding={12}
      borderStyle="solid"
      borderRadius={4}
      showBoxShadow
      flex={1}
      flexDirection="row"
      color={BrandColor.CreamCorn2}
    >
      <Inline space={8}>
        <ShareArrowIcon iconFillColor={BrandColor.Punch} iconSize={24} />
        <Inline alignItems="center">
          <HeaderText level={4} style={{ lineHeight: 'initial', fontWeight: '500' }}>Give and get up to&nbsp;</HeaderText>
          <HeaderText level={4} style={{ lineHeight: 'initial' }}>$50 off</HeaderText>
        </Inline>
      </Inline>
    </Box>
  </Touchable>
);
